import { Card, Center, Loader, Table } from '@mantine/core';
import type { ReactNode } from 'react';

type WorkflowsTableProps = {
  columns: string[];
  hasActions?: boolean;
  isLoading: boolean;
  children: ReactNode;
};

export const WorkflowsTable = ({
  columns,
  hasActions = false,
  isLoading,
  children,
}: WorkflowsTableProps) => (
  <Card radius={8} p={0}>
    <Table highlightOnHover verticalSpacing="sm">
      <Table.Thead bg="purple.1">
        <Table.Tr>
          {columns.map(column => (
            <Table.Th key={column} c="purple.5">
              {column}
            </Table.Th>
          ))}
          {hasActions && <Table.Th w={60} />}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{children}</Table.Tbody>
    </Table>
    {isLoading && (
      <Center py="md">
        <Loader size="sm" />
      </Center>
    )}
  </Card>
);
